// extracted by mini-css-extract-plugin
export default {"contentBlock":"styles_contentBlock__znub7","main":"styles_main__Kl5to"};